module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('h1', [_vm._v("Epigraph")]), _vm._v(" "), _c('p', [_vm._v("*…España,")]), _vm._v(" "), _c('p', [_vm._v("madre de ríos y de espadas y de multiplicadas generaciones,")]), _vm._v(" "), _c('p', [_vm._v("incesante y fatal.*")]), _vm._v(" "), _c('p', [_vm._v("(…Spain,")]), _vm._v(" "), _c('p', [_vm._v("mother of rivers and swords and multiplied generations,")]), _vm._v(" "), _c('p', [_vm._v("incessant and fatal.)")]), _vm._v(" "), _c('p', [_vm._v("Jorge Luis Borges, Buenos Aires, July 1964.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c22c3d46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch002.vue
// module id = 66
// module chunks = 0